<template>
  <div class="detail">
    <div class="title">{{ article.title }}</div>
    <div class="description">
      <div class="description-txt">发布时间: {{ article.createTime }}</div>
      <div class="description-txt">作者: {{ article.author }}</div>
      <div class="description-txt">来源: {{ article.source }}</div>
    </div>
    <div class="bor"></div>
    <div class="content" v-html="formatRichText(article.content)"></div>
  </div>
</template>

<script>
export default {
  props: {
    article: Object,
  },
  methods: {
    formatRichText(html) {
      //控制小程序中图片大小
      let newContent = "";
      if (typeof html == "string") {
        //检测值为字符串才能进行replace操作
        newContent = html.replace(/<img[^>]*>/gi, function (match) {
          // match = match
          //   .replace(/style="[^"]+"/gi, "")
          //   .replace(/style='[^']+'/gi, "");
          // match = match
          //   .replace(/width="[^"]+"/gi, "")
          //   .replace(/width='[^']+'/gi, "");
          // match = match
          //   .replace(/height="[^"]+"/gi, "")
          //   .replace(/height='[^']+'/gi, "");
          return match;
        });
        // newContent = newContent.replace(/style="[^"]+"/gi, function (match) {
        //   match = match
        //     .replace(/width:[^;]+;/gi, "max-width:100%;")
        //     .replace(/width:[^;]+;/gi, "max-width:100%;");
        //   return match;
        // });
		
        // newContent = newContent.replace(/<br[^>]*>/gi, "");
        // newContent = newContent.replace(
        //   /<img/gi,
        //   '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"'
        // );
		newContent = newContent.replace(/<video[^>]*">/gi, '<video controls="controls" width="100%" height="auto">');
        return newContent;
      }
    },
  },
};
</script>

<style lang="less" scoped>
	
.detail {
  width: 100%;
  .editor {
    margin-top: 25px;
    color: #656565;
    font-size: 16px;
  }
  .content {
    width: 100%;
    margin-top: 40px;
    word-break: break-all;
  }
  .bor {
    margin-top: 15px;
    width: 100%;
    border: 1px dashed #dddddd;
  }
  .description {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    .description-txt {
      margin-top: 25px;
      color: #656565;
      font-size: 16px;
    }
  }
  .title {
    width: 810px;
    margin: 0 auto;
    margin-top: 40px;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }
}
</style>